import { debounce, hasHorizontalScrollBar, hasVerticalScrollBar, animate } from '../functions.js';

export default function ScrollGradientModule(element) {

    let gradientMargin = 10;

    let scrollGradient;
    let scrollStartDiv;
    let scrollEndDiv;

    function init() {

        initHtml();

        element.addEventListener('scroll', debounce(function() {
            addGradients();
        }, 100));

        addGradients();
    }

    function initHtml() {
        scrollGradient = document.createElement('div');
        scrollGradient.classList.add('scroll-gradient');

        scrollStartDiv = document.createElement('div');
        scrollStartDiv.classList.add('scroll-gradient-start');

        scrollEndDiv = document.createElement('div');
        scrollEndDiv.classList.add('scroll-gradient-end');

        scrollGradient.appendChild(scrollStartDiv);
        scrollGradient.appendChild(scrollEndDiv);

        element.parentNode.insertBefore(scrollGradient, element.nextSibling);

        scrollGradient.appendChild(element);
    }

    function addGradients() {

        var animOptions = { duration: 500 };

        if (hasVerticalScrollBar(element)) {

            scrollGradient.classList.remove('scroll-gradient--horizontal');

            var diff = (element.scrollHeight - element.scrollTop) - element.clientHeight;

            if (diff <= gradientMargin) {
                animate(scrollEndDiv, {'opacity': 0}, 500);
            } else {
                animate(scrollEndDiv, {'opacity': 1}, 500);
            }

            if (element.scrollTop <= gradientMargin) {
                animate(scrollStartDiv, {'opacity': 0}, 500);
            } else {
                animate(scrollStartDiv, {'opacity': 1}, 500);
            }

        } else if (hasHorizontalScrollBar(element)) {

            scrollGradient.classList.add('scroll-gradient--horizontal');

            var diff = (element.scrollWidth - element.scrollLeft) - element.clientWidth;

            if (diff <= gradientMargin) {
                animate(scrollEndDiv, {'opacity': 0}, 500);
            } else {
                animate(scrollEndDiv, {'opacity': 1}, 500);
            }

            if (element.scrollLeft <= gradientMargin) {
                animate(scrollStartDiv, {'opacity': 0}, 500);
            } else {
                animate(scrollStartDiv, {'opacity': 1}, 500);
            }

        }
        
    }

    init();

}

window.modules = window.modules || {}
window.modules.ScrollGradientModule = ScrollGradientModule;
